// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__kbBmv","show":"LoadingOverlay_show__9eYMR","text":"LoadingOverlay_text__iS2bY"};